import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'

const IsResident = () => {
  const { t, errors, isResident, showIsResident, updateAddress } = useAddress()
  if (!showIsResident) {
    return null
  }
  return (
    <FormControl
      label={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: mandatoryTag + t('subscriptionForm:address_module.is_resident'),
          }}
        />
      )}
      error={getError('isResident', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => {
          updateAddress({ isResident: value })
        }}
        options={[{ 1: t('common:yes_text') }, { 0: t('common:no_text') }]}
        selectedValue={String(Number(isResident))}
      />
    </FormControl>
  )
}

export default IsResident
